import { UserFlags } from "@clockwise/client-commons/src/util/flags";
import { useFlags } from "@clockwise/web-commons/src/util/FlagsContext";

export const useChecklistFlags = () => {
  const { isFlagSet, setFlag } = useFlags();

  const hasCompletedSchedulingChecklistItem = isFlagSet(
    UserFlags.NUX.HasCompletedSchedulingChecklistItem.name,
  );
  const hasCompletedReschedulingChecklistItem = isFlagSet(
    UserFlags.NUX.HasCompletedReschedulingChecklistItem.name,
  );
  const hasCompletedPreferencesChecklistItem = isFlagSet(
    UserFlags.NUX.HasCompletedPreferencesChecklistItem.name,
  );

  const isChecklistCompleted =
    hasCompletedSchedulingChecklistItem &&
    hasCompletedReschedulingChecklistItem &&
    hasCompletedPreferencesChecklistItem;

  const setCompletedSchedulingChecklistItem = () => {
    setFlag(UserFlags.NUX.HasCompletedSchedulingChecklistItem.name, true);
  };

  const setCompletedReschedulingChecklistItem = () => {
    setFlag(UserFlags.NUX.HasCompletedReschedulingChecklistItem.name, true);
  };

  const setCompletedPreferencesChecklistItem = () => {
    setFlag(UserFlags.NUX.HasCompletedPreferencesChecklistItem.name, true);
  };

  // Only to be used in testing to reset the checklist items
  const resetAllChecklistItems = () => {
    setFlag(UserFlags.NUX.HasCompletedSchedulingChecklistItem.name, false);
    setFlag(UserFlags.NUX.HasCompletedReschedulingChecklistItem.name, false);
    setFlag(UserFlags.NUX.HasCompletedPreferencesChecklistItem.name, false);
  };

  return {
    isChecklistCompleted,
    schedulingCompleted: hasCompletedSchedulingChecklistItem,
    reschedulingCompleted: hasCompletedReschedulingChecklistItem,
    preferencesCompleted: hasCompletedPreferencesChecklistItem,
    completeSchedulingChecklistItem: setCompletedSchedulingChecklistItem,
    completeReschedulingChecklistItem: setCompletedReschedulingChecklistItem,
    completePreferencesChecklistItem: setCompletedPreferencesChecklistItem,
    resetAllChecklistItems,
  };
};
